import { keyframes } from "@emotion/react";
import { vars } from "@imwebme/clay-token";
import type { ModalContainerProps } from "./Modal.types";

export const modalSizeMap = {
  medium: "540px",
  full: "100%",
  large: "720px",
  small: "380px",
} satisfies Record<ModalContainerProps["width"], string>;

export const overlayAnimation = keyframes`
  from {
    background-color: transparent;
  }

  to {
    background: ${vars.semantic.color.backdrop};
  }
`;

export const contentAnimation = keyframes`
    from {
        transform: translateY(30px);
        opacity: 0;
    }

    to {     
        transform: translateY(0);
        opacity: 1;
    }
`;
